import { useTranslation } from 'react-i18next';

import { Typography } from '@mui/material';

const NoScenario = () => {
  const { t } = useTranslation('common');
  return <Typography variant="h6">{t('noScenarioSelected')}</Typography>;
};

export default NoScenario;
